import type { SiteAlertState } from '@cloudsign/shared';
import { t } from '../../lib/i18n';

/** Full-screen red evacuation message with muster points and directions. Shows no names, ever. */
export function EvacuationScreen({ alert }: { alert: SiteAlertState }) {
  const drill = alert.kind === 'drill';
  return (
    <main role="alert" className="fixed inset-0 flex cursor-none flex-col gap-[3vmin] overflow-hidden bg-red-700 p-[4vmin] text-white">
      <h1 className="text-[clamp(3rem,10vmin,10rem)] font-extrabold uppercase leading-none">{drill ? t('displayUi.evac.drillTitle') : t('displayUi.evac.title')}</h1>
      <p className="text-[clamp(1.75rem,4.2vmin,4.5rem)] font-semibold">{drill ? t('displayUi.evac.drillInstruction') : t('displayUi.evac.instruction')}</p>
      <section aria-labelledby="muster-heading" className="mt-[2vmin] min-h-0 flex-1">
        <h2 id="muster-heading" className="mb-[2vmin] text-[clamp(1.5rem,3.4vmin,3.5rem)] font-bold uppercase tracking-wide">
          {t('displayUi.evac.points')}
        </h2>
        {alert.points.length === 0 ? (
          <p className="text-[clamp(1.5rem,3.6vmin,4rem)]">{t('displayUi.evac.noPoints')}</p>
        ) : (
          <ul className="grid gap-[2vmin] landscape:grid-cols-2">
            {alert.points.map((p) => (
              <li key={p.id} className="rounded-[1.5vmin] bg-white p-[2.5vmin] text-red-900">
                <p className="text-[clamp(1.75rem,4.4vmin,4.5rem)] font-bold leading-tight">{p.name}</p>
                {p.directions ? <p className="mt-[1vmin] text-[clamp(1.25rem,3vmin,3rem)] leading-snug">{p.directions}</p> : null}
              </li>
            ))}
          </ul>
        )}
      </section>
    </main>
  );
}
